/* eslint-disable @typescript-eslint/consistent-type-definitions */
import { createGlobalInstance, getGlobalInstance } from '@/utils/state'

import { ClientAppState } from './ClientAppState'

export interface AppStateRegister {}

export let clientAppState: ClientAppState = getGlobalInstance('clientAppState')

export const initClientAppState = (state: ClientAppState) => {
    clientAppState = createGlobalInstance('clientAppState', () => state)
}

export * from './ClientAppState'
